import React, { useState, useEffect } from 'react'
import { Dialog, Box, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

import { requests } from '../../../../core/ajax'
import { BasicTable, ThemeButton } from '../../../../ui'
import { IPInstallersForm } from './ip-installers-form.component'
import { feedback } from '../../../../core/feedback'

export const IPInstallersTable = ({ data = [], companyId }) => {
  const { getById, post, putById, deleteById } = requests
  const [open, setOpen] = useState(false)
  const [tableData, setTableData] = useState([])
  const [currentRow, setCurrentRow] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const sortedData = [...data].sort(
      (a, b) => new Date(b['dg_ts_insert']) - new Date(a['dg_ts_insert'])
    )
    setTableData(sortedData || [])
  }, [data])

  const handleClose = () => {
    setCurrentRow({})
    setOpen(false)
  }

  const fetchTableData = async () => {
    try {
      const response = await getById('/empresa', companyId)
      const sortedData = (response.data.inspectores || []).sort(
        (a, b) => new Date(b['dg_ts_insert']) - new Date(a['dg_ts_insert'])
      )
      setTableData(sortedData)
    } catch (error) {
      console.error('Error fetching updated data:', error)
      feedback('error', 'No se pudo recargar la lista de instaladores.')
    }
  }

  const handleSubmit = async (_, formData) => {
    setIsLoading(true)
    try {
      if (formData.id) {
        await putById('/inspectores', formData.id, formData)
      } else {
        const payload = { ...formData, empresa_id: companyId }
        await post('/inspectores', payload)
      }
      await fetchTableData()

      feedback('success', 'Instalador guardado correctamente')
      handleClose()
    } catch (error) {
      const message = error?.response?.data?.message || 'No se ha podido guardar el instalador'
      feedback('error', message)
      console.error('Error saving inspector:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleOpenModal = (row) => {
    setCurrentRow(row || {})
    setOpen(true)
  }

  const handleDelete = async (rowToDelete) => {
    try {
      await deleteById('/inspectores', rowToDelete.id)
      setTableData((currentData) => currentData.filter((item) => item.id !== rowToDelete.id))
      feedback('success', 'Instalador eliminado')
    } catch (error) {
      const message = error?.response?.data?.message || 'No se ha podido eliminar el instalador'
      feedback('error', message)
      console.error('Error deleting inspector:', error)
    }
  }

  const IPInstallersTableActions = ({ row }) => {
    const actionButtonStyles = {
      borderRadius: '100%',
      border: '1px solid #333',
      height: '1.7em',
      width: '1.7em',
    }

    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
        <IconButton sx={actionButtonStyles} size="small" onClick={() => handleOpenModal(row)}>
          <EditOutlinedIcon />
        </IconButton>
        <IconButton sx={actionButtonStyles} size="small" onClick={() => handleDelete(row)}>
          <DeleteIcon />
        </IconButton>
      </Box>
    )
  }

  const INSTALLERS_TABLE_CONFIG = [
    { key: 'nombre', label: 'Nombre completo' },
    { key: 'identificador', label: 'NIF/NIE' },
    { key: 'categoria', label: 'Categoría' },
    { key: 'codigo', label: 'Código Instalador' },
    { key: 'id', label: 'Acciones', type: 'component', component: IPInstallersTableActions },
  ]

  return (
    <Box width="100%">
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <ThemeButton onClick={() => handleOpenModal()}>Añadir</ThemeButton>
      </Box>
      <BasicTable data={tableData} config={INSTALLERS_TABLE_CONFIG} />
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <Box p={3}>
          <IPInstallersForm
            onSubmit={handleSubmit}
            onClose={handleClose}
            data={currentRow}
            tableData={tableData}
            isLoading={isLoading}
          />
        </Box>
      </Dialog>
    </Box>
  )
}
